import React from 'react';
import VacantesComponent from './Vacantes';

const Catalogos = () => {

    //validations
    const validationMessages = {
        techName: [
            {
                type: 'required',
                message: 'Favor ingresar el nombre de la tecnología',
            },
        ],
    }

    return (
        <div>
            <VacantesComponent validationMessages={validationMessages} />
        </div>
    );
};

export default Catalogos;